import type { ReactNode } from 'react';
import React, { Component } from 'react';

import { get } from 'src/helper/helper';
import HttpService from 'src/services/api/http';
import history from 'src/services/routing/history';
import { UserContext } from 'src/components/app/context/UserContext';

export type AfterLoginCallback = (authKey: string, onDone: () => void) => void;

interface LoginConsumerComponentProps {
  loadUser: () => Promise<boolean | void>;
  wipeUser: () => Promise<void>;
  render: (afterLogin: AfterLoginCallback) => void;
}

export class LoginConsumerComponent extends Component<LoginConsumerComponentProps> {
  // after every login the auth token must be set, the user must be loaded and the onDone function must be called.
  // the afterLogin function shows exactly this behaviour. It also makes use of promises to assure, that functions
  // are called in the right order.
  afterLogin: AfterLoginCallback = (authKey, onDone) => {
    HttpService.setAuthToken(get(() => authKey));
    this.props.wipeUser().then(() =>
      this.props
        .loadUser()
        .then(onDone)
        .catch(() => history.push('/')),
    );
  };

  render() {
    return this.props.render(this.afterLogin) as ReactNode;
  }
}

// We use functions provided by the context in the component-function afterLogin. In order to have access to this
// function we need to inject the context into the props through a wrapper function.
const LoginConsumerWrapper = ({
  render,
}: {
  render: (afterLogin: AfterLoginCallback) => void;
}) => (
  <UserContext.Consumer>
    {({ loadUser, wipeUser }) => (
      <LoginConsumerComponent
        loadUser={loadUser}
        wipeUser={wipeUser}
        render={render}
      />
    )}
  </UserContext.Consumer>
);

export default LoginConsumerWrapper;
